//
// Module for the Death Setup wizard's Payment Option step
//
rs.module("participant/benefit/setup/death/wizard/paymentoptionstep",

    ["controls/components/event-banner",
     "common/visibility"],

    function (eventBanner, visibility) {

        // Initialize the module
        function initialize(jsSelectors, variablePayOptionKeys) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var payOptionSelect = stepContainer.js(jsSelectors.payOptionSelect);
            var variablePayOptionsContainer = stepContainer.js(jsSelectors.variablePayOptionsContainer);

            // Hookup payOptionSelect change event
            payOptionSelect.change(payOptionChange);

            // Pay Option change event
            function payOptionChange() {

                // Get selected Pay Option Key
                var selectedPayOptionKey = payOptionSelect.val();

                // clear any messages in the message banner
                eventBanner.removeAllMessages();

                // set visibility of beneficiaries container
                visibility.setVisible(variablePayOptionsContainer, selectedPayOptionKey && variablePayOptionKeys.includes(selectedPayOptionKey));
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);